var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mod-container",class:(_vm.dark ? 'mod-dark' : '')},[_c('h4',[_vm._v("Lessons")]),_c('div',{staticClass:"lesson-list-container"},[_c('div',{staticClass:"project-list"},[_c('ul',{staticStyle:{"padding":"0px"}},_vm._l((( 
                        _vm.$route.params.current == 'advisory'
                        ? 
                        _vm.quizzes.advisory
                        : 
                        (
                            _vm.$route.params.current == 'managed_services' 
                            ?
                            _vm.quizzes.managedServices 
                            : 
                            (
                                _vm.$route.params.current == 'operations'
                                ?
                                _vm.quizzes.operations 
                                :
                                _vm.quizzes.keno
                            )
                            
                        )
                    )),function(item,index){return _c('router-link',{key:item.i,attrs:{"to":'/lesson/' + item.lessonID}},[_c('li',[_c('div',{staticClass:"project-item",class:(_vm.globalCompleted.includes(parseInt(item.lessonID)) ? 'completed' : ''),style:((_vm.globalCompleted.includes(parseInt(item.lessonID)) 
                                ? 'background-color:' + _vm.color + ' !important; color: white !important;' + 'animation: flyin 300ms forwards ease ' + parseFloat(index / 6) + 's' 
                                : 'background-color:#00000000;' + 'animation: flyin 300ms forwards ease ' + parseFloat(index / 6) + 's'))},[_c('div',{staticClass:"left"},[_c('strong',[_vm._v(_vm._s(item.practiceGroup))]),_c('span',[_vm._v(_vm._s(item.serviceLine))])]),_c('div',{staticClass:"right"},[_vm._v(_vm._s(_vm.globalCompleted.includes(parseInt(item.lessonID)) ? '✓' : '🡒'))])])])])}),1)])])])}
var staticRenderFns = []

export { render, staticRenderFns }